import * as React from "react";
import Box from "@material-ui/core/Box";
import styled from "styled-components";

export const FirstLoginLayout: React.FC<any> = ({children}) => {
    return (
        <StyledLayoutBox
            display="flex"
            flexDirection={'column'}
        >
            <Box
                flexGrow={1}
                flexDirection="row"
                display="flex"
            >
                <StyledContentBox
                    display={'flex'}
                    flex={1}
                >
                    {children}
                </StyledContentBox>
            </Box>
        </StyledLayoutBox>
    );
}

const StyledLayoutBox = styled(Box)`
    height: 100vh;
`;

const StyledContentBox = styled(Box)`
    padding: 50px 20px 20px;
`;
